import React, { useState } from "react";
import { GrClose } from "react-icons/gr";
import { HiOutlineMenuAlt2 } from "react-icons/hi";
import { Link } from "react-router-dom";
import logo from "../assets/img/logo.png";
const Header = () => {
	const [menuOpen, setMenuOpen] = useState(false);

	const menuToggle = () => {
		setMenuOpen(!menuOpen);
	};
	return (
		<>
			<header className="bg--section ">
				<div className="container">
					<div className="header-wrapper">
						<div className="logo">
							<Link to="/">
								<img src={logo} alt="img" />
							</Link>
						</div>
						<div className={`menu-wrapper ${menuOpen ? "open" : ""}`}>
							<div
								className="close-menu d-lg-none"
								onClick={() => menuToggle()}
							>
								<GrClose />
							</div>
							<ul>
								<li>
									<a href="/#">Website</a>
								</li>
								<li>
									<a href="/#">Lp mining</a>
								</li>
								<li>
									<a href="/#">Staking</a>
								</li>
								<li>
									<a href="/#">CMC</a>
								</li>
							</ul>
						</div>
						<div
							className="menu-toggle d-lg-none"
							onClick={() => menuToggle()}
						>
							<HiOutlineMenuAlt2 />
						</div>
						<Link to="/form" className="cmn--btn">
							Connect Wallet
						</Link>
					</div>
				</div>
			</header>
		</>
	);
};

export default Header;
